import { FileText, Clock } from "lucide-react";

export default function InvoiceReports() {
  return (
    <div className="min-h-[calc(100vh-120px)] flex items-center justify-center bg-[#F8FAFC] px-6">
      <div className="w-full max-w-xl rounded-2xl border border-[#E5E7EB] bg-white p-12 text-center shadow-sm">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-blue-50">
          <FileText className="h-10 w-10 text-[#007BFF]" />
        </div>

        <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-blue-100 bg-blue-50 px-4 py-1.5 text-sm font-medium text-[#007BFF]">
          <Clock className="h-4 w-4" />
          Coming Soon
        </div>

        <h1 className="mb-3 text-3xl font-bold text-[#1F2937]">
          Invoice Reports
        </h1>

        
      </div>
    </div>
  );
}